import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import {Form, Control} from "react-redux-form";
import { getQuestion, submitAnswer, downloadFile, getDownloadTime } from "../reducers/questions";
import {Link} from "react-router-dom";
import SanitizeHTML from 'react-sanitized-html'
import ReactStopwatch from "react-stopwatch";
import {zeroPad} from "react-countdown";
import { hasReadWarning, showWarning } from "../reducers/auth";
import Loading from "../components/loading";
const moment = require('moment');

const Renderer = ({ days, hours, minutes, seconds }) => {
	return (
		<div className="timer">
			<div className="box-shadow">
				<p>time since download</p>
				<ul>
					<li><span id="hours">{zeroPad(hours)}</span>Hours</li>
					<li className="timer-after">:</li>
					<li><span id="minutes">{zeroPad(minutes)}</span>Minutes</li>
					<li className="timer-after">:</li>
					<li><span id="seconds">{zeroPad(seconds)}</span>Seconds</li>
				</ul>
			</div>
		</div>
	)
};

class CustomCountdown extends Component {
	duration(t0, t1){
		var day = new Date();
		var now = moment.utc(day.toUTCString());
		var then = moment.utc(t0);

		let ms = now.diff(then)

		var d, h, m, s;
		s = Math.floor(ms / 1000);
		m = Math.floor(s / 60);
		s = s % 60;
		h = Math.floor(m / 60);
		m = m % 60;
		d = Math.floor(h / 24);
		h = h % 24;

		return {days: d, hours: h, minutes: m, seconds: s};
	}

	constructor(props) {
		super(props);

		var a = new Date('2020-05-15 12:00:00'),
			b = new Date(),
			diff = (+a - +b);

		this.state = {
			timerOn: true,
			timerStart: 0,
			timerTime: diff
		}
	}

	startTimer = (diff) => {
		this.setState({
			timerOn: true,
			timerTime: this.state.timerTime,
		});

		this.timer = setInterval(() => {
			const newTime = this.state.timerTime + 10;

			if (newTime >= 0) {
				this.setState({
					timerTime: newTime
				});
			}
			else {
				clearInterval(this.timer);
				this.setState({ timerOn: false });
			}
		}, 10);
	};

	componentDidMount() {
		this.startTimer();
	}

	render(){
		let {days, hours, minutes, seconds} = this.duration(this.props.questions.currentQuestion.downloadTime);
		return <Renderer days={days} hours={hours} minutes={minutes} seconds={seconds}  />
	}
}

class Stopwatch extends Component {
	componentDidMount() {
		// this.props.getDownloadTime()
	}

	render(){
		if(!this.props.questions.currentQuestion.downloadTime)
			return null

		return (
			<ReactStopwatch
				seconds={this.props.questions.currentQuestion.downloadTimeParsed.seconds}
				minutes={this.props.questions.currentQuestion.downloadTimeParsed.minutes}
				hours={this.props.questions.currentQuestion.downloadTimeParsed.hours}
				render={({ formatted, hours, minutes, seconds }) => {
					return (
						<div className="timer">
							<div className="box-shadow">
								<p>time since download</p>
								<ul>
									<li><span id="hours">{zeroPad(hours)}</span>Hours</li>
									<li className="timer-after">:</li>
									<li><span id="minutes">{zeroPad(minutes)}</span>Minutes</li>
									<li className="timer-after">:</li>
									<li><span id="seconds">{zeroPad(seconds)}</span>Seconds</li>
								</ul>
							</div>
						</div>
					);
				}}
			/>
		)
	}
}

class Warning extends Component {
	render(){
		return (
			<React.Fragment>
				<div onClick={() => this.props.hasReadWarning()} className="the-modal-overlay" />

				<div className="the-modal">
					<div className="fancybox-content">
						<h2 data-selectable="true">Warning</h2>
						<div className="text mt-4" data-selectable="true">
							{!this.props.content && <p>It is highly recommended you use a Virtual Machine during this IR Challenge. <br /><br />The VM should be disconnected from the host machine itself and has no internet connection. Some of the downloaded files may contain malicious files or files which can cause damage to the host itself. Using an isolated VM will allow completion of the challenge with the ability to recover from any related unwanted situations, without damaging your host machine.</p>}
							{this.props.content && <p>{this.props.content}</p>}
						</div>

						<div className="text-right mb-3 mb-sm-0">
							<button onClick={() => this.props.hasReadWarning()} className="btn-blue_light bold btn-hover text-center sign-up mt-3 ml-auto">GOT IT</button>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}
}

class Challenge extends Component {
	componentWillMount() {
		window.scrollTo(0,0);
		this.props.getQuestion(this.props.match.params.challenge_id);
		// this.props.getDownloadTime()
	}

	render() {
		if(!this.props.questions.currentQuestion || !this.props.questions.currentQuestion.Answers)
			return <Loading {...this.props} />

		let breadClass = '';
		if(this.props.questions.currentQuestion.Difficulty.Title === 'Medium'){
			breadClass = 'm';
		}
		else if(this.props.questions.currentQuestion.Difficulty.Title === 'Advanced') {
			breadClass = 'h';
		}

		return (
			<main className="">
				{!this.props.auth.hasReadWarning && <Warning content={this.props.questions.currentQuestion.WarningContent} {...this.props} />}

				<section className="bread-crumbs bg-color_gradient paddingLeft-120">
					<ul className="d-flex">
						<li>
							<Link to={'/'}>All Challenges</Link>
						</li>
						<li className={'active_' + breadClass}>
							<Link to={'/'}>{this.props.questions.currentQuestion.Difficulty.Title}</Link>
						</li>
						<li>{this.props.questions.currentQuestion.Title}</li>
					</ul>
				</section>

				<section className="content bg-color_gradient paddingLeft-150 shadow-top">
					<div className="row">

						<div className="col-12">
							<h3 className="blue-text bold mb-5">{this.props.questions.currentQuestion.Title}</h3>
						</div>

						<div className="col-12 col-lg-6">
							<div className="text">
								<h3 className="white-text">Story</h3>
								<SanitizeHTML html={this.props.questions.currentQuestion.Content}/>
							</div>
							<div className="download">
								<div className="title">Download Files</div>
								<div className="download__block">

									{this.props.questions.currentQuestion.Downloads && this.props.questions.currentQuestion.Downloads.map((item, key) => {
										return (
											<div key={key} className="download__down">
												<button onClick={() => this.props.downloadFile(item.Id)} className="item">
													<p>Download File</p>

													<img src={require("../img/arrow-bottom.png")} alt="" />
												</button>
											</div>
										)
									})}
								</div>
							</div>
						</div>

						<div className="col-12 col-lg-6">
							<div className="instruct">
								<div className="title">Instructions</div>
								<div className="text">
									<SanitizeHTML html={this.props.questions.currentQuestion.Instructions}/>
								</div>
								<div className="form-style">
									{this.props.questions.currentQuestion.downloadTime && <CustomCountdown {...this.props} />}

									{this.props.questions.currentQuestion.answerInvalid && <p className={'error'}>Please enter a valid answer.</p>}

									<Form model={'questions.currentQuestion'} onSubmit={this.props.submitAnswer}>
										{this.props.questions.currentQuestion.Answers.map((answer, key) => {
											if(!!answer.Choices){
												return (
													<div key={key} className="position-relative input-effect">
														<Control.select
															required={true}
															model={'.Answers['+key+'].GivenAnswer'}
															className={!!this.props.questions.currentQuestion.Answers[key].GivenAnswer ? 'effect has-content' : 'effect'}
														>
															<option value="" />
															{answer.Choices.map((item, key) => {
																return <option key={key} value={item}>{item}</option>
															})}
														</Control.select>

														<label>{answer.Label}</label>
													</div>
												)
											}

											return (
												<div key={key}  className="position-relative input-effect">
													<Control.text required={true} model={'.Answers['+key+'].GivenAnswer'} className={!!this.props.questions.currentQuestion.Answers[key].GivenAnswer ? 'effect has-content' : 'effect'} />
													<label>{answer.Label}</label>
												</div>
											)
										})}

										<input type="submit" className="submit bold btn-hover" value="SUBMIT" />
									</Form>
								</div>
							</div>
						</div>

					</div>
				</section>
			</main>
		);
	}
}

function mapStateToProps(state) {
	return {
		questions: state.questions,
		auth: state.auth
	};
}

const mapDispatchToProps = dispatch => bindActionCreators({
	getQuestion,
	submitAnswer,
	downloadFile,
	getDownloadTime,
	hasReadWarning,
	showWarning
}, dispatch)

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Challenge);